import Card from '@mui/material/Card';
import { FileAttachableType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import type { JSX } from 'react';

import FileAttachmentsReadOnly from '~components/Files/FileAttachmentsReadOnly';

import { useOrderFormV3Context } from '../OrderFormV3Context';

/**
 * Renders read-only project attachments. Render-only conditional wrapper:
 * the card tracks the currently selected project via the watched `project`
 * form value (`watchedProject?.id`), so it previews on select, updates on
 * switch, and disappears the instant the dropdown is cleared (TRE-15327).
 * It deliberately does NOT read the persisted `defaultOrder` or the
 * `projectData` entity — both keep the last project after deselection,
 * which would strand a stale preview. With no project selected the card is
 * absent, not empty. The watch lives in the Provider; the panel only
 * consumes context (never a panel-level watch). The embedded legacy
 * FileAttachmentsReadOnly (no fork) owns the attachment fetch and the list
 * rendering.
 */
export function ProjectAttachmentsPanel(): JSX.Element | null {
  const { watchedProject } = useOrderFormV3Context();

  const previewProjectId = watchedProject?.id;
  if (!previewProjectId) {
    return null;
  }

  return (
    <Card sx={{ p: 2, pt: 0, mb: 2 }}>
      <FileAttachmentsReadOnly
        label={t('form_fields.project_attachments')}
        fileAttachableId={previewProjectId}
        fileAttachableType={FileAttachableType.PROJECT}
      />
    </Card>
  );
}
